<div class="dialog-select-floors" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'フロア・表示グループリスト一覧' | translate}}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="selectFloors()">
          <mat-icon>add</mat-icon>
          <span>{{'設定' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="filter-field">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center" fxFlex="500px" style="overflow: auto;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let floor; let i = index">{{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
          <span>{{'全' | translate}}</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="floor_id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let floor"> {{ floor.floor_id }} </td>
      </ng-container>

      <ng-container matColumnDef="explain">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'説明' | translate}}</th>
        <td mat-cell *matCellDef="let floor"> {{ floor.floor_explain }} </td>
      </ng-container>

      <ng-container matColumnDef="hall">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'建物・カテゴリ' | translate}}
        </th>
        <td mat-cell *matCellDef="let floor">
          <span *ngFor="let hall of (floor.hall_id | docsByCond:hallsCollectionName:'hall_id' | async)">
            {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="floor">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'フロア・表示グループ' | translate}}</th>
        <td mat-cell *matCellDef="let floor"> {{ floor.floor_names | multiName:projectLanguages:projectBaseLang }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator class="page" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>


</div>